var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.76 5.21429L10.16 0.214286C10 0.0714285 9.84 0 9.6 0H1.6C0.72 0 0 0.642857 0 1.42857V18.5714C0 19.3571 0.72 20 1.6 20H14.4C15.28 20 16 19.3571 16 18.5714V5.71429C16 5.5 15.92 5.35714 15.76 5.21429ZM9.6 1.71429L14.08 5.71429H9.6V1.71429ZM14.4 18.5714H1.6V1.42857H8V5.71429C8 6.5 8.72 7.14286 9.6 7.14286H14.4V18.5714Z",
    fill: "#9097A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.19922 13.1426H12.7992V14.6569H3.19922V13.1426Z",
    fill: "#9097A5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.19922 9.59961H12.7992V11.1139H3.19922V9.59961Z",
    fill: "#9097A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.b5fa09d28bc97fb5e25df1ec87677100.svg";
export { ForwardRef as ReactComponent };